import { render } from "./quick-add.vue?vue&type=template&id=ef84aefc"
import script from "./quick-add.vue?vue&type=script&lang=js"
export * from "./quick-add.vue?vue&type=script&lang=js"

import "./quick-add.vue?vue&type=style&index=0&id=ef84aefc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__